// Core
import QS from "qs";
import { AxiosRequestConfig } from "axios";
import { http } from "@/network/http-provider";

// Definitions
import type {
  GameType,
  GameInitParamsType,
  GameInitType,
  GameListType,
  GamesFilterParamsType,
} from "./types";
import { HttpRequestParams } from "@/types/http";

// Utils
import { gamesKeys } from "./apiKeys";

export const gamesApi = Object.freeze({
  fetchGames: (payload: HttpRequestParams<void, GamesFilterParamsType>) => {
    const { params } = payload;
    const config = {
      params,
      paramsSerializer: (p: AxiosRequestConfig): string =>
        QS.stringify(p, { encode: true, arrayFormat: "indices" }),
    };
    return http.get<GameListType>(gamesKeys.games, config);
  },
  fetchOneGame: (payload: HttpRequestParams<void, { slug: [string, string] }>) => {
    const { params } = payload;
    return http.get<GameType>(
      `${gamesKeys.games}/${String(params?.slug[0])}/${String(params?.slug[1])}`,
    );
  },
  initGameDemo: (payload: GameInitParamsType) => {
    const { data } = payload;
    return http.post<GameInitType>(gamesKeys.demoInitGame, data);
  },
  initGame: (payload: HttpRequestParams<GameInitParamsType>) => {
    const { data } = payload;
    return http.post<GameInitType>(gamesKeys.initGame, data?.data, { ...data?.configOptions });
  },
});
